import { ajax } from '@setel/webcommon/exposes/ajax';
import { environments } from 'environments/environment';

const BASE_URL = `${environments.apiOpsBaseUrl}/api/verifications`;

export interface IUserVerifications {
  verificationDate: Date;
  callbackDate: Date;
  firstAttemptDate: Date;
  dateOfBirth: Date;
  livenessImages: string[];
  referenceId: string;
  customerId: string;
  callbackStatus: string;
  verificationStatus: VerificationStatus;
  systemIdentifiedVerificationStatus: string;
  classification: string;
  rejectCode: string;
  rejectReason: string;
  attemptNum: number;
  idType: string;
  idNumber: string;
  firstName: string;
  lastName: string;
  fullName: string;
  mobileNum: string;
  passportExpiredAt: Date;
  gender: string;
  country: string;
  countryDisplayName: string;
  updateRemarks: string;
  lastUpdatedByUser: string;
}

export enum VerificationStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export const getUserVerifications = (userId: string) => {
  return ajax
    .get<IUserVerifications[]>(`${BASE_URL}/verifications?customerId=${userId}`)
    .then((data) => {
      return data?.[0];
    });
};
